export default __webpack_public_path__ + "static/media/logo.7c677d2a.svg";